<template>
  <div class="root">
    <!-- 描边 -->
    <div
      class="image-set bdline"
      v-if="config.property_data.border_spacing_type == 1"
    >
      <div
        class="flex-wra"
        @click="jump(link_data[0].link_data)"
        v-if="config.style_type == 1 && link_data.length === 1"
      >
        <div
          class="content-img"
          :class="link_data[0].image_url ? '' : 'style-1'"
        >
          <img
            :src="link_data[0].image_url || default_imgurl_border"
            :class="link_data[0].image_url ? '' : 'default-img-40'"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CallApp from "callapp-lib";
import c from "crypto-js";
/**
 * 加密算法
 */
function getAccEncryption(a) {
  //加密
  let r = "";
  try {
    var k = c.enc.Utf8.parse(
      [
        109, 42, 111, 38, 107, 94, 117, 37, 97, 36, 105, 35, 116, 64, 118, 33,
      ].reduce(
        (pre, next) =>
          (pre = typeof pre == "number" ? String.fromCharCode(pre) : pre) +
          String.fromCharCode(next)
      )
    );
    var d = c.AES.encrypt(a, k, {
      mode: c.mode.ECB,
      padding: c.pad.Pkcs7,
    });
    r = d.toString();
  } catch (error) {
    console.log(error);
  }
  return r;
}

export default {
  name: "tms-jump_app",
  props: ["config", "theme", "isEditorStatus"],

  data() {
    return {
      default_imgurl:
        "https://img.mockuai.com/tms/2018/1/10/upload_48dfb5b82f032311cb9207f142a95b89.png",
      default_imgurl_border:
        "https://img.mockuai.com/tms/2018/1/13/upload_ed4e75f3608d59cbd803c5e3a98960af.png",
      isAndroid:
        navigator.userAgent.indexOf("Android") > -1 ||
        navigator.userAgent.indexOf("Adr") > -1,
      isiOS: !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
    };
  },

  components: {},

  mounted() {},
  computed: {
    link_data() {
      return this.config.link_data || {};
    },
    style_type() {
      return this.config.style_type;
    },
    property_data() {
      return this.config.property_data;
    },
  },
  methods: {
    jump(item) {
      if (this.isEditorStatus || !item) {
        return;
      }
      this.handlerOpenApp(item.toString());
    },
    handlerOpenApp(url) {
      //安卓手机
      if (this.isAndroid) {
        const options = {
          scheme: {
            protocol: "mockuaiseller",
          },
          appstore:
            "https://apps.apple.com/cn/app/%E9%AD%94%E7%AD%B7%E6%98%9F%E9%80%89%E5%95%86%E5%AE%B6%E7%89%88/id1444722447",
          yingyongbao:
            "https://a.app.qq.com/o/simple.jsp?pkgname=com.mockuai.mkselleros&fromcase=40003",
          fallback:
            "https://a.app.qq.com/o/simple.jsp?pkgname=com.mockuai.mkselleros&fromcase=40003",
          timeout: 3000,
        };
        const callLib = new CallApp(options);
        if (url.startsWith("http")) {
          callLib.open({
            param: {
              url: encodeURIComponent(url),
              link_type: 1,
            },
            path: "seller/webview",
          });
        } else {
          callLib.open({
            param: {
              url: encodeURIComponent(url),
              link_type: 1,
            },
            path: url.split("://")[1],
          });
        }
      } else {
        const iosLink = `https://download.mockuai.com/mkseller/item/index.html?router=`;
        // ios手机
        // 传给ios客户端的参数先AES加密,为了避免出现"="这样的字符导致ios客户端解析参数获取错误,需要再encodeURI处理一下
        let iosLinkParam = getAccEncryption(url);
        window.location.href =
          iosLink + encodeURI(iosLinkParam) + "&link_type=" + 1;
      }
    },
  },
};
</script>
<style  lang="scss" scoped>
@import "./index.scss";
</style>